module.exports = __webpack_public_path__ + "img/5-3.18303fa6.svg";